import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

const defaultFieldSx = {
  display: "flex",
  flexDirection: "column",
  minWidth: 0,
};

const defaultLabelSx = {
  display: "block",
  mb: 0.5,
  color: "var(--text-muted, #667085)",
  fontSize: "11px",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.035em",
  lineHeight: 1.3,
};

const defaultValueSx = {
  fontSize: "13px",
  fontWeight: 650,
  color: "text.primary",
  lineHeight: 1.4,
  overflowWrap: "anywhere",
};

export default function AppInfoField({
  label,
  value,
  children,
  emptyText = "—",
  fullWidth = false,
  span,
  labelSx,
  valueSx,
  sx,
  className,
  ...props
}) {
  const displayValue =
    value !== null && value !== undefined && value !== "" ? value : emptyText;
  const isSpanSet = Boolean(span || fullWidth);
  const gridColumnValue = fullWidth ? "1 / -1" : span ? `span ${span}` : undefined;

  return (
    <Box
      className={`app-info-field ${className || ""}`.trim()}
      sx={{
        ...defaultFieldSx,
        ...(isSpanSet && { gridColumn: gridColumnValue }),
        ...sx,
      }}
      {...props}
    >
      {label &&
        (typeof label === "string" ? (
          <Typography component="label" sx={{ ...defaultLabelSx, ...labelSx }}>
            {label}
          </Typography>
        ) : (
          label
        ))}
      {children ? (
        children
      ) : typeof displayValue === "string" || typeof displayValue === "number" ? (
        <Typography component="strong" sx={{ ...defaultValueSx, ...valueSx }}>
          {displayValue}
        </Typography>
      ) : (
        displayValue
      )}
    </Box>
  );
}

AppInfoField.propTypes = {
  label: PropTypes.node,
  value: PropTypes.node,
  children: PropTypes.node,
  emptyText: PropTypes.node,
  fullWidth: PropTypes.bool,
  span: PropTypes.number,
  labelSx: PropTypes.object,
  valueSx: PropTypes.object,
  sx: PropTypes.object,
  className: PropTypes.string,
};
